export const routes = {
    loginRoute: 'login',
    errors: 'errors',
    app: 'app',
    contract: 'contract',
    sendReminder: 'sendReminder',
    notConfirmedContract: 'notconfirmed',
    confirmedContract: 'confirmed',
    accepted: 'accepted',
    refused: 'refused',
    expired: 'expired',
    statusCode201: '201',
    statusCode404: '404',
    statusCode520: '520',
    statusCode301: '301',
};
